module.exports = __webpack_public_path__ + "img/benzhub0.0057ec42.png";